import styled from '@emotion/styled';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import RoomIcon from '@material-ui/icons/Room';
import GoogleMapReact from 'google-map-react';
import React from 'react';

export default function Map({ center, id, height }) {
	return (
		<div style={{ height: height || '330px', width: '100%', position: 'relative', marginTop: '0.5rem', marginBottom: '0.5rem' }}>
			<GoogleMapReact
				bootstrapURLKeys={{ key: 'AIzaSyAdsY0wBf3_4RMZ7wVycpcMSNLSmf8H4D8' }}
				defaultCenter={!!center ? center : { lat: 51.506686, lng: -0.149912 }}
				defaultZoom={15}
			>
				{!!center && (
					<Marker lat={center.lat} lng={center.lng}>
						<Icon />
						<Info>
							<Typography variant="body1">{id}</Typography>
						</Info>
					</Marker>
				)}
			</GoogleMapReact>
		</div>
	);
}

const Icon = styled(RoomIcon)`
	color: #b60037;
	cursor: pointer;
	font-size: 32px;
	width: 45px;
	height: 45px;
`;
const Info = styled(Paper)`
	z-index: 0;
	text-align: center;
	min-width: 130px;
	padding: 0.5rem;
	position: absolute;
	top: 0;
	left: -42px;
	transition: all 0.2s ease-in;
	opacity: 0;
`;
const Marker = styled.div`
	transform: translate(-50%, -50%);
	z-index: 1;
	position: relative;
	&:hover {
		& > div {
			top: -45px;
			opacity: 1;
		}
	}
`;
